<div class="contentContainer">

    <!------------------------------------------------------------------------------ header -->

    <div fxLayout="row" fxLayoutAlign="space-between center" class="headerContentContainer">
        <div fxLayout="row">
            <div fxLayoutAlign="center center" class="grayLink" (click)="routeService.goBack()">
                <mat-icon class="linkIcon ft22">arrow_back</mat-icon>
            </div>
            <div>
                <h6 class="mgl10 ft500 ft16 mgb0 gray-9"> Empresas cliente</h6>
            </div>
        </div>
        <div fxLayout="row">
            <div routerLink="/admin/form-empresas-cliente" class="mgl10 sqChip ft12 ft500 backGray9 shadow20">
                Agregar
            </div>
        </div>
    </div>


    <!------------------------------------------------------------------------------ Table -->
    <div class="tableContainer">

        <table style="width:100%">

            <!-- Table Header -->
            <tr class="headerContentContainer">
                <th>Nombre</th>
                <th>Cant. Estudiantes</th>
                <th>Cant. Cursos</th>
                <th>Fecha Cr.</th>
            </tr>

            <!-- Table Data -->
            <tr *ngFor="let item of [1,2,3,4];  let i=index">
                <td class="centertext">
                    <a class="blueLink">Nombre</a>
                </td>
                <td class="centertext"> Cant. Estudiantes</td>
                <td class="centertext"> Cant Cursos</td>
                <td class="centertext"> Fecha Cr.</td>
            </tr>
        </table>
    </div>

</div>